import { render } from "./AssetVideoViewDetail.vue?vue&type=template&id=7b29e188"
import script from "./AssetVideoViewDetail.vue?vue&type=script&lang=js"
export * from "./AssetVideoViewDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/mbsm-pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__